<template>
  <div class="lessonDetail">
    <nav-header></nav-header>
    <section class="main sec-main">
      <div class="video-wrapper"  v-if="list.length">
        <div class="head">大咖面对面&gt;<i class="on">详情页</i></div>
        <h3 class="title">{{title}}</h3>
        <div class="video-box">
          <video ref="video" class="video" controls :src="list[showIndex].VideoUrl"></video>
        </div>
        <div class="summary">{{list[showIndex].ChapterTitle }}</div>
        <p class="desc">{{list[showIndex].Content }}</p>
      </div>
      <aside class="aside">
        <h3 class="case-title">目录</h3>
        <ul class="video-list">
          <li v-for="(item,index) in list" :key="index" :class="{on:index==showIndex}" @click="changeVideo(index)">
            <i class="num">{{index+1}}</i>
            <div class="name">{{item.ChapterTitle }}</div>
            <!-- <div class="time">播放时长：12:15</div> -->
          </li>
        </ul>
      </aside>
    </section>
    <gk-footer></gk-footer>
  </div>
</template>
<script>
import NavHeader from '@/components/navHeader.vue'
import gkFooter from '@/components/footer.vue'
import {aesDecrypt} from '@/scripts/aesHelper.js'
import {
  GetMasterMediaDetailVO,
} from '@/scripts/api.js'
import {mapState} from 'vuex'
export default {
  components:{
    NavHeader,
    gkFooter,
  },
  data(){
    return{
      isShowVideo:false,
      title:'',
      list:[],
      showIndex:0,
    }
  },
  computed:{
    ...mapState({
      userInfo:state=>state.userInfo,
    })
  },
  created() {
    this.pageInit();
  },
  methods: {
    pageInit(){
      let self = this
      GetMasterMediaDetailVO({
        MasterId:this.$route.query.id
      }).then(r=>{
        if(r.Result==1){
          this.title=r.Data.Title;
          this.list=r.Data.ChapterList;
          for(let i in this.list) {
            this.list[i].VideoUrl = aesDecrypt(r.Data.ChapterList[i].VideoUrl,2)
          }
        }else{
          this.$toast(r.Message);
        }
      })
    },
    changeVideo(index){
      this.showIndex=index;
    }
  },
}
</script>
<style lang="scss">
.lessonDetail{
  padding-top:68px;
  .sec-main{
    min-height: 85vh;
    overflow: hidden;
    padding-top: 30px;
  }
  .video-wrapper{
    width: 850px;
    float: left;
    .head{
      font-size: 16px;
      color: #333;
      line-height: 24px;
      margin-bottom: 10px;
      .on{
        color: #f75959;
      }
    }
    .title{
      font-size: 24px;
      color: #333;
      line-height: 30px;
      font-weight: bold;
      margin-bottom: 10px;
    }
    .summary{
      font-size: 24px;
      color: #333;
      line-height: 30px;
      font-weight: bold;
      margin-bottom: 20px;
    }
    .desc{
      font-size: 16px;
      color: #666;
      line-height: 24px;
    }
  }
  .video-box{
    background-color: #fff;
    width: 860px;
    height: 500px;
    overflow: hidden;
    position: relative;
    margin-bottom: 10px;
    .icon{
      position: absolute;
      left: 50%;
      top: 50%;
      z-index: 3;
      font-size: 110px;
      transform: translate3d(-50%,-50%,0);
      color: #fff;
      opacity: 0.8;
    }
    .video-face{
      display: block;
      width: 100%;
      height: 100%;
    }
    .video{
      width: 100%;
      height: 100%;
    }
  }
  .aside{
    float: right;
    width: 310px;
    padding-top: 24px;
    .case-title{
      font-size: 18px;
      color: #333;
      line-height: 30px;
      margin-bottom: 20px;
      text-align: center;
      font-weight: bold;
      &:after,&:before{
        content: "";
        display: inline-block;
        vertical-align: middle;
        width: 60px;
        height: 1px;
        background-color: #f75959;
        margin: -3px 10px 0;
      }
    }
  }
  .video-list{
    background-color: #f9f9f9;
    min-height: 500px;
    padding-top: 20px;
    li{
      margin-bottom: 10px;
      overflow: hidden;
      padding: 0 10px;
      cursor: pointer;
      &.on,&:hover{
        .name{
          color: #333;
        }
        .num{
          background-color: #f75959;
        }
      }
    }
    .num{
      float: left;
      font-size: 12px;
      color: #fff;
      line-height: 20px;
      text-align: center;
      height: 20px;
      min-width: 20px;
      margin-right: 12px;
      background-color: #999;
    }
    .name{
      float: left;
      font-size: 16px;
      color: #999;
      line-height: 24px;
      font-weight: bold;
      width: 258px;
    }
    .time{
      float: left;
      width: 100%;
      padding-left: 32px;
      font-size: 14px;
      color: #999;
      line-height: 24px;
    }
  }
}
</style>